/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnSubLnbUploadRequest model module.
 * @module model/SystemControllerDtoMnSubLnbUploadRequest
 * @version 1.0
 */
class SystemControllerDtoMnSubLnbUploadRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnSubLnbUploadRequest</code>.
     * @alias module:model/SystemControllerDtoMnSubLnbUploadRequest
     * @param gnbNo {Number} 
     * @param lnbNo {Number} 
     * @param subName {String} 
     */
    constructor(gnbNo, lnbNo, subName) { 
        
        SystemControllerDtoMnSubLnbUploadRequest.initialize(this, gnbNo, lnbNo, subName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, gnbNo, lnbNo, subName) { 
        obj['gnbNo'] = gnbNo;
        obj['lnbNo'] = lnbNo;
        obj['subName'] = subName;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnSubLnbUploadRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnSubLnbUploadRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnSubLnbUploadRequest} The populated <code>SystemControllerDtoMnSubLnbUploadRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnSubLnbUploadRequest();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('subName')) {
                obj['subName'] = ApiClient.convertToType(data['subName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnSubLnbUploadRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnSubLnbUploadRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnSubLnbUploadRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['subName'] && !(typeof data['subName'] === 'string' || data['subName'] instanceof String)) {
            throw new Error("Expected the field `subName` to be a primitive type in the JSON string but got " + data['subName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}

SystemControllerDtoMnSubLnbUploadRequest.RequiredProperties = ["gnbNo", "lnbNo", "subName"];

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['subNo'] = undefined;

/**
 * @member {String} subName
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['subName'] = undefined;

/**
 * @member {String} pageUrl
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['enabled'] = undefined;

/**
 * @member {String} key
 */
SystemControllerDtoMnSubLnbUploadRequest.prototype['key'] = undefined;






export default SystemControllerDtoMnSubLnbUploadRequest;

